export default __webpack_public_path__ + "static/mockSeikaku1-da88c560ce133d2d333d0d9924ec322b.png";